// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__2VhfU","totalContent":"style_totalContent__2iOlY","logo":"style_logo__3R7aK","menus":"style_menus__2OrAF","menu":"style_menu__2tkQX"};